/**
 * Auto Incrementing ID
 *
 * SQL-style ID generation!
 *
 * ```typescript
 * const IDs = new AutoIncrementingID();
 *
 * const uniqueID = IDs.get();
 * ```
 */
export class AutoIncrementingID {
    incrementor = -1;
    /**
     * Get
     *
     * Returns an auto-incrementing ID
     */
    get() {
        return `${++this.incrementor}`;
    }
    /**
     * Last
     *
     * Returns the last generated ID
     */
    last() {
        return `${this.incrementor}`;
    }
    /**
     * Reset
     *
     * Resets the `AutoIncrementingID`'s incrementor back to 0
     */
    reset() {
        this.incrementor - 1;
    }
}
